export default __webpack_public_path__ + "static/media/repairer.f36d3aa5.svg";